import React from "react";
import Router from "./Routes"
import ReactDOM from "react-dom"
import Routes from "./Routes";

ReactDOM.render(<Routes/>,document.getElementById("root"))
